import { Spinner } from '@99designs/common/components/Spinner';
import Button from 'common/components/Button';
import { Field } from 'common/components/Form';
import { login } from 'launch/common/xhr/accounts';
import Link from 'launch/components/Link';
import PrivacyLink from 'launch/components/PrivacyLink';
import TermsLink from 'launch/components/TermsLink';
import * as React from 'react';

interface AuthLoginFormProps {
    title: React.ReactNode;
    postLogin?: () => Promise<void>;
    onSuccess: () => void;
    email: string;
}

interface AuthLoginFormState {
    errors: { [key: string]: string };
    email: string;
    password: string;
    busy: boolean;
}

class AuthLoginForm extends React.Component<AuthLoginFormProps, AuthLoginFormState> {
    constructor(props: AuthLoginFormProps) {
        super(props);
        this.state = {
            errors: {},
            password: '',
            email: '',
            busy: false,
        };
    }

    email: HTMLInputElement | null;
    componentDidMount() {
        if (this.email) {
            this.email.focus();
        }
    }

    attachTo = <T extends keyof AuthLoginFormState>(name: T) => {
        return {
            value: this.state[name],
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                this.setState({
                    ...this.state,
                    [name]: e.target.value,
                });
            },
        };
    };

    render() {
        const { title } = this.props;

        return (
            <form onSubmit={this.handleOnSubmit} className="modal-form modal-form--wide">
                <div className="modal-form__title">{title}</div>
                <div className="modal-form__input">
                    <Field errorMessage={this.state.errors.email}>
                        <input
                            name="email"
                            placeholder={__('Email address')}
                            ref={input => (this.email = input)}
                            className="input-text"
                            {...this.attachTo('email')}
                            required
                        />
                    </Field>

                    <Field
                        errorMessage={this.state.errors.password}
                        className="field--last"
                        message={
                            <Link href="/accounts/resetpassword" variations={['default']}>
                                {__('Forgot password?')}
                            </Link>
                        }
                    >
                        <input
                            name="password"
                            type="password"
                            placeholder={__('Password')}
                            className="input-text"
                            {...this.attachTo('password')}
                        />
                    </Field>
                </div>

                <div className="modal-form__submit">
                    <Button typeAttribute="submit" variation={'primary'}>
                        {__('Log in')}
                    </Button>
                    {this.state.busy && <Spinner variations={['inline', 'login']} />}
                </div>
                <div className="modal-form__footer">
                    <div className="field__message">
                        <span> © 99designs </span>
                        <PrivacyLink /> <TermsLink />
                    </div>
                </div>
            </form>
        );
    }

    handleOnSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        const { onSuccess, postLogin } = this.props;
        const { email, password } = this.state;

        this.setState({ busy: true });

        e.preventDefault();
        try {
            await login(email, password);

            if (postLogin) {
                await postLogin();
            }
        } catch (errors) {
            this.setState({
                errors: errors || {
                    email: __(
                        'Uh oh. Unfortunately, we’ve got a slight problem. Please try again in a few minutes.'
                    ),
                },
            });
            return;
        } finally {
            this.setState({ busy: false });
        }

        onSuccess();
    };
}

export default AuthLoginForm;
